export const SHOW_RAW_DATA_MODAL = "SHOW_RAW_DATA_MODAL";
export const SHOW_RAW_DATA_MODAL_HIDE = "SHOW_RAW_DATA_MODAL_HIDE";
